module.exports = require("node:inspector");